import { type Command } from "@telespot/core";

/**
 * Payload for {@link GrantRoles}
 *
 * @group Authentication & Authorization
 * @category Payloads
 */
export interface GrantRolesDetails {
  userId: string;
  /**
   * Array of role names to grant to the user
   */
  roles: string[];
}

/**
 * Registration token for {@link GrantRoles}
 *
 * @group Authentication & Authorization
 * @category Tokens
 */
export const GRANT_ROLES = "roles:grant";

/**
 * Grants specified roles to the user given a userId
 * Throws a {@link GrantRoleErrors.ROLE_NOT_FOUND} error if one of the roles does not exist
 *
 * @group Authentication & Authorization
 * @category Commands
 */
export class GrantRoles implements Command<typeof GRANT_ROLES, GrantRolesDetails> {
  public readonly name = GRANT_ROLES;
  constructor(public readonly details: Readonly<GrantRolesDetails>) { }
}
